import { render, staticRenderFns } from "./ContentCustomServiceBoxItem.vue?vue&type=template&id=1b96a9be&"
import script from "./ContentCustomServiceBoxItem.vue?vue&type=script&lang=js&"
export * from "./ContentCustomServiceBoxItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports